export function loadinguploadtitle(data){
    const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    if(data == 100){
        loading.close();
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/wx-upload.js